import { FormInputMeta } from '@Modules/core/types/FormMetaType';
import { getValidationSchema } from '@Shared/utils/validationSchema';
import * as yup from "yup";


export interface ICurrencyDefinitionFormMeta {
    myId: FormInputMeta;
    name: FormInputMeta;
    symbol: FormInputMeta;
    alphaCode: FormInputMeta;
    schema: any;
  }

const CurrencyDefinitionFormMeta = {} as ICurrencyDefinitionFormMeta;

CurrencyDefinitionFormMeta.myId = {
  name: "myId",
  label: "ID",
  type: "text",
  validation: yup.string().required(),
}
CurrencyDefinitionFormMeta.name = {
  name: "name",
  label: "Nom",
  type: "text",
  validation: yup.string().required(),
}
CurrencyDefinitionFormMeta.symbol = {
  name: "symbol",
  label: "Symbole",
  type: "text",
  validation: yup.string().required(),
}
CurrencyDefinitionFormMeta.alphaCode = {
  name: "alphaCode",
  label: "Code alphabetique",
  type: "text",
  validation: yup.string().required(),
}



CurrencyDefinitionFormMeta.schema = yup.object().shape(getValidationSchema(CurrencyDefinitionFormMeta));

export default CurrencyDefinitionFormMeta;